__turbopack_context__.v({
  "storedetails": "store-details-component-module-scss-module__FLTs3a__storedetails",
});
